import { displayValue } from "./utils/mapperUtils";

const SETTINGS_PATH = "/:locale(pt|en|lt|es|ro|fr)?/settings";

const packageFilterLink = (id, fieldId, counter, path) => {
    const count = Number(counter);

    if (!count) {
        return {
            customComponent: "SettingsFilterLink",
            id: fieldId,
            name: "N/A",
        };
    }

    return {
        customComponent: "SettingsFilterLink",
        id: fieldId,
        name: counter,
        customParam: {},
        link: {
            to: `${SETTINGS_PATH}/${path}`,
            filter: [
                {
                    filters: [{ value: `${id}` }],
                    column: "packageId",
                    operator: "equals",
                },
            ],
        },
    };
};

export const mapCard = (json) => {
    const { id, name, description, kpisCounter, rulesCounter, crCounter } = json;
    return [
        [
            {
                labels: ["id"],
                value: displayValue(id),
                type: "string",
                basis: "10%",
            },
        ],
        [
            {
                labels: ["packageName"],
                value: displayValue(name),
                type: "string",
                basis: "35%",
            },
        ],
        [
            {
                labels: ["description"],
                value: displayValue(description),
                type: "string",
                basis: "50%",
            },
        ],
        [
            {
                label: ["kpisCounter"],
                value: packageFilterLink(id, "kpisCounter", kpisCounter, "kpis"),
                type: "customComponent",
                align: "center",
                basis: "10%",
            },
        ],
        [
            {
                label: ["rulesCounter"],
                value: packageFilterLink(id, "rulesCounter", rulesCounter, "nc_rules"),
                type: "customComponent",
                align: "center",
                basis: "10%",
            },
        ],
        [
            {
                label: ["crCounter"],
                value: packageFilterLink(id, "crCounter", crCounter, "custom_reports"),
                type: "customComponent",
                align: "center",
                basis: "10%",
            },
        ],
        [
            {
                label: ["edit"],
                value: {
                    customComponent: "SettingsFilterLink",
                    id: "Edit",
                    name: "Edit",
                    __typename: "PackageNavigation",
                    customParam: { id: `${id}` },
                    link: {
                        to: `${SETTINGS_PATH}/:section/packages-association/:id/package_rules`,
                    },
                },
                type: "customComponent",
                align: "center",
                basis: "10%",
            },
        ],
    ];
};

const mapper = (json, card) => {
    return {
        ...json,
        name: json.name,
        shortName: json.name,
        card: card ? mapCard(json) : [],
    };
};

const header = [
    {
        label: ["Identifier"],
        align: "left",
        basis: "10%",
        columnName: "id",
        sortable: true,
    },
    {
        label: ["Package Name"],
        basis: "35%",
        align: "left",
        columnName: "name",
        sortable: true,
    },
    {
        label: ["Description"],
        align: "left",
        columnName: "description",
        sortable: true,
        basis: "50%",
    },
    {
        label: ["Kpis"],
        align: "center",
        columnName: "kpisCounter",
        basis: "10%",
        type: "customComponent",
    },
    {
        label: ["Rules"],
        align: "center",
        columnName: "rulesCounter",
        basis: "10%",
        type: "customComponent",
    },
    {
        label: ["Custom Reports"],
        align: "center",
        columnName: "crCounter",
        basis: "10%",
        type: "customComponent",
    },
    {
        label: ["Associate"],
        align: "center",
        columnName: "edit",
        basis: "10%",
        type: "customComponent",
    },
];

const packageMapper = {
    map: mapper,
    header,
};

export default packageMapper;
